import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSuccessNotification } from '../services/common';
import {
  addTemplate,
  deleteTemplate,
  editTemplate,
  generateTemplateReport,
  reactivateTemplate,
  setTemplateDailyQuota,
} from '../services/templates';

export const useCreateTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation(addTemplate, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['templates']).then(() => {});
      queryClient.invalidateQueries(['templatesCount']).then(() => {});
      showSuccessNotification('Template has been created successfully.');
    },
  });
};

export const useUpdateTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation(editTemplate, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['templates']).then(() => {});
      showSuccessNotification('Template has been edited successfully.');
    },
  });
};

export const useReactivateTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation(reactivateTemplate, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['templates']).then(() => {});
      showSuccessNotification('Template has been reactivated successfully.');
    },
  });
};

export const useDeleteTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteTemplate, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['templates']).then(() => {});
      queryClient.invalidateQueries(['templatesCount']).then(() => {});
      showSuccessNotification('Template has been deleted successfully.');
    },
  });
};

export const useGenerateTemplateReport = () => {
  const queryClient = useQueryClient();
  return useMutation(generateTemplateReport, {
    onSuccess: () => {
      queryClient.invalidateQueries(['templateReportStatus']).then(() => {});
      showSuccessNotification(
        'Request to generate template report successfully',
      );
    },
  });
};

export const useSetTemplateDailyQuota = queryFilter => {
  const queryClient = useQueryClient();
  return useMutation(setTemplateDailyQuota, {
    onSuccess: async () => {
      if (queryFilter) queryClient.invalidateQueries(queryFilter);
      showSuccessNotification('Template Daily Quota updated successfully');
    },
  });
};
